import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

class DisplayProducts extends Component {
  handleCartItems = (e, data) => {
    e.preventDefault();
    this.props.addCartItems(data);
  };

  render() {
    const { data, cartItems } = this.props;
    return (
      <Fragment>
        <div className="productContainer">
          <img src={data.imgUrl} alt={data.title} />
          <hr />
          <h2>{data.title} </h2>
          <p>
            {data.currencyFormat} {data.price}
          </p>
           <button
            className="cartButton"
            onClick={e => this.handleCartItems(e, data)}
          >
            Add to cart
          </button>
        </div>
      </Fragment>
    );
  }
}

DisplayProducts.propTypes = {
  cartItems: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    .isRequired,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  addCartItems: PropTypes.func.isRequired
};

export default DisplayProducts;
